import { useState } from 'react';
import MailConfirmationAnimation from '@/components/animations/MailConfirmationAnimation';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import AuthLayout from './AuthLayout';

export default function VerifyEmail() {
    const { login, logout } = useAuth();
    const [isChecking, setIsChecking] = useState(false);

    const handleCheckEmail = async () => {
        setIsChecking(true);
        try {
            await login({ returnTo: '/' });
        } catch (error) {
            console.error('Failed to restart authentication flow:', error);
        } finally {
            setIsChecking(false);
        }
    };

    return (
        <AuthLayout
            leftPanel={
                <div className="flex size-full items-center justify-center p-8 lg:p-12">
                    <MailConfirmationAnimation
                        className="w-full max-w-md lg:max-w-lg"
                        loop={true}
                    />
                </div>
            }
        >
            <div className="m-auto w-full max-w-lg text-center">
                <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground">
                    Verifique seu e-mail
                </h2>

                <p className="mb-8 leading-relaxed text-muted-foreground">
                    Para garantir a segurança da sua conta, precisamos que você verifique seu
                    endereço de e-mail. Enviamos um link de confirmação para sua caixa de entrada.
                </p>

                <div className="space-y-4">
                    <Button
                        size="xl"
                        className="w-full"
                        onClick={handleCheckEmail}
                        disabled={isChecking}
                    >
                        {isChecking ? 'Verificando...' : 'Já verifiquei meu e-mail'}
                    </Button>

                    <Button variant="outline" size="xl" className="w-full" onClick={() => logout()}>
                        Voltar para o login
                    </Button>
                </div>

                <p className="mt-8 text-sm text-muted-foreground">
                    Não recebeu o e-mail? Verifique sua pasta de spam ou tente fazer login
                    novamente.
                </p>
            </div>
        </AuthLayout>
    );
}
